import McpRole from '@/bundles/Roles/models/McpRole';
import McpPermission from '@/bundles/Roles/models/McpPermission';
import { IMcpRoleApi } from '@/bundles/Roles/types';

export default class McpRoleMapper {
  mapToModel (data: IMcpRoleApi): McpRole {
    return new McpRole({
      ...data,
      permissions: (data.permissions ?? []).map((permission) => new McpPermission(permission)),
    });
  }
}
